import React from "react";
import { Grid, TextField } from "@mui/material";

export default function PersonnelIdField({ value, classes, onChange }) {
  const handleChange = (e) => {
    const val = e.target.value;
    if (val !== "" && !/^[0-9\b]+$/.test(val)) return;
    onChange({ personnel_id: val });
  };

  return (
    <>
      <Grid
        item
        xs={4}
        sm={1.5}
        sx={{
          fontWeight: "bold",
          paddingLeft: { sm: "20px" },
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        技術提供主(要員)ID
      </Grid>
      <Grid
        item
        xs={8}
        sm={2.5}
        sx={{
          borderLeft: 1,
          borderColor: "#F2F3F4",
          paddingTop: "10px",
          paddingBottom: "20px",
          paddingLeft: { sm: "20px" },
        }}
      >
        <TextField
          className={classes?.inputArea}
          variant="standard"
          fullWidth
          name="personnelID"
          id="personnelID"
          value={value || ""}
          InputProps={{
            style: { fontSize: 16 },
          }}
          onChange={handleChange}
        />
      </Grid>
    </>
  );
}